import classNames from "classnames";

import BuildsStore from "app/stores/BuildsStore";

import { filterJobs } from "./utils/job";
import { Step } from "./Step";
import groupJobs from "./utils/groupJobs";
import JobGroup from "./utils/jobGroup";
import { Job } from "./types/Job";

// FIXME: this is a workaround to get the BuildPageStore loaded - see https://github.com/buildkite/buildkite/pull/10514 for more detail
require("app/components/job/Job");

export type Build = {
  id: string;
  path: string;
  jobs?: Array<Job>;
  jobsCount?: number;
};

/**
 * This component renders a list of build steps, and handles the grouping of jobs.
 * For builds that are truncated, it will render a link to the build page.
 */
export default function Steps({
  build,
  store,
  showHiddenJobs,
  small,
}: {
  build: Build;
  store: BuildsStore;
  showHiddenJobs?: boolean;
  small?: boolean;
}) {
  if (build.jobs?.length === 0) {
    return (
      <p className="text-danger my1">
        There are no build steps for this pipeline. To add a step, go to your
        Pipeline Settings.
      </p>
    );
  }

  if (!build.jobs) {
    return (
      <p className="dark-gray my1">
        Steps can&apos;t be displayed for this build.
      </p>
    );
  }

  // If a build has hidden jobs, we turn off the grouping behaviour
  const truncated = build.jobs && build.jobs.length !== build.jobsCount;

  const jobs = filterJobs(build.jobs, showHiddenJobs);
  const groupedJobs = groupJobs(jobs);

  return (
    <>
      {groupedJobs.map((job: Job | JobGroup) => (
        <Step
          key={job.id}
          job={job}
          build={build}
          buildStore={store}
          className={classNames(small && "build-pipeline-job--small")}
        />
      ))}

      {truncated && (
        <a
          key={`${build.id}-more-jobs`}
          href={build.path}
          className={classNames("build-pipeline-job truncate align-middle", {
            "build-pipeline-job--small": small,
          })}
        >
          ...
        </a>
      )}
    </>
  );
}
